import React from "react";

const BoldStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.75 2.75H10.5C12.5711 2.75 14.25 4.42893 14.25 6.5C14.25 8.5711 12.5711 10.25 10.5 10.25H4.75V2.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.75 10.25H11.75C13.683 10.25 15.25 11.817 15.25 13.75C15.25 15.683 13.683 17.25 11.75 17.25H4.75V10.25Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(BoldStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;